import classNames from 'classnames';
import React from 'react';
import Icon from '../../wui-icon/src';
import { NoticeProps, Color, MappingColor } from './iNotification';

// const propTypes = {
//     duration: PropTypes.number,
//     onClose: PropTypes.func,
//     children: PropTypes.any,
//     color: PropTypes.oneOf(['info', 'success', 'danger', 'warning', 'light', 'dark', 'news', 'infolight', 'successlight', 'dangerlight', 'warninglight']),
//     title: PropTypes.any,
//     closable: PropTypes.bool,
//     style: PropTypes.object,
//     content: PropTypes.any,
//     onEnd: PropTypes.func,
//     fieldid: PropTypes.string
// };

function noop() {
}
const defaultProps = {
    onEnd: noop,
    onClose: noop,
    duration: 4.5,
    closable: true,
    color: "light"
}

class Notice extends React.Component<NoticeProps> {
    static defaultProps = defaultProps;
    closeTimer: ReturnType<typeof setTimeout> | null = null;
    constructor(props: NoticeProps) {
        super(props);
        this.clearCloseTimer = this.clearCloseTimer.bind(this);
        this.close = this.close.bind(this);
    }

    componentDidMount() {
        if (this.props.duration) {
            this.closeTimer = setTimeout(() => {
                this.close();
            }, this.props.duration * 1000);
        }
    }

    componentWillUnmount() {
        this.clearCloseTimer();
    }

    clearCloseTimer() {
        if (this.closeTimer) {
            clearTimeout(this.closeTimer);
            this.closeTimer = null;
        }
    }

    close() {
        this.clearCloseTimer();
        this.props.onClose?.();
    }

    notifiClick = (e: React.MouseEvent) => {
        this.props.onClick?.(e);
    }

    render() {
        const {
            closable,
            clsPrefix,
            className,
            style,
            children,
            color,
            title,
            fieldid,
            // eslint-disable-next-line no-unused-vars
            content,
            // eslint-disable-next-line no-unused-vars
            onEnd,
            // eslint-disable-next-line no-unused-vars
            onClose,
            // eslint-disable-next-line no-unused-vars
            duration,
            icon,
            closeIcon,
            btn,
            ...others
        } = this.props;
        const componentClass = `${clsPrefix}-notice`;
        const classes = {
            [`${componentClass}`]: 1,
            [`${componentClass}-closable`]: closable,
            [className ?? ""]: !!className,
        };
        let iconType = ({
            info: 'uf uf-i-c',
            success: 'uf uf-correct',
            danger: 'uf uf-exc-c',
            error: 'uf uf-exc-c',
            warning: 'uf uf-exc-t',
            light: 'uf',
            dark: 'uf',
            news: 'uf uf-bell',
            infolight: 'uf uf-i-c',
            successlight: 'uf uf-correct',
            dangerlight: 'uf uf-exc-c',
            warninglight: 'uf uf-exc-t',
        })[color as Color];
        // bip:强制转成light风格
        const mapping: MappingColor = {
            success: "successlight",
            info: "infolight",
            danger: "dangerlight",
            error: "dangerlight",
            warning: "warninglight",
        }
        let _color = '';
        if (color) {
            let tempColor = color in mapping ? mapping[color] : color;
            classes[`${componentClass}-${tempColor}`] = true;
            _color = color || '';
        }
        return (
            <div className={classNames(classes)} style={style} onClick={this.notifiClick} {...others}>
                <div className={`${componentClass}-content`}>
                    {title && (<div className={`${componentClass}-title`}>{icon ? icon : <i className={iconType}></i>}{title}</div>)}
                    <div className={`${componentClass}-description`}>
                        {children}
                    </div>
                    {btn ?
                        <div className={`${componentClass}-btn`} onClick={this.close}>
                            {btn}
                        </div> : null}
                </div>
                {closable ?
                    <a fieldid={fieldid ? `${fieldid}_${_color}_close` : undefined} tabIndex={0} onClick={this.close} className={`${componentClass}-close`}>
                        <span className={`${componentClass}-close-x`}>{closeIcon ? closeIcon : <Icon type="uf-close"/>}</span>
                    </a> : null
                }
            </div>
        );
    }
}

// Notice.propTypes = propTypes;
// Notice.defaultProps = defaultProps;

export default Notice;
